@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../constants/spacing.module.less';
@import (reference) '../../../../style.module.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';

@fontSize: 12px;
@headerFontSize: 16px;

.component-header,
.bundle-component {
  display: grid;
  grid-template-columns: 410px 90px 120px 90px 90px;
  font-size: @fontSize;
  border: 1px solid @product-page--variants--border-color;
  border-bottom: 0;
  > div {
    padding: @space-8 @space-16;
  }
}

.bundle-component {
  border-right: 1px solid @product-page--variants--border-color;
  border-left: 1px solid @product-page--variants--border-color;
  &:last-child {
    border-bottom: 1px solid @product-page--variants--border-color;
  }
  &.centered {
    justify-content: center;
  }
}

.bundle-component-sku {
  color: @product-page--sku--text-color;
  font-size: @fontSize;
  margin-top: @space-4;
}

.components {
  display: flex;
  width: 100%;
  flex-direction: column;
  padding: 0 20px;
}

.component-title {
  padding-bottom: @space-12;
  border-bottom: 1px solid @product-page--variants-title--border-color;
}

.component-wrapper {
  padding: @space-12 0;
}

.component-header {
  background-color: @product-page--variants--background-color;
  font-weight: 500;
}

.auto-complete-dropdown {
  min-width: 300px;
  max-width: 300px;
  max-height: 160px;
  overflow: auto;
}

.add-component {
  text-align: center;
}

.total-available-title {
  font-size: @headerFontSize;
  font-weight: 500;
  padding: @space-8;
  margin: @space-16 0 0 @space-12;
}

.total-available-helper-text {
  font-size: @fontSize;
  padding: @space-8;
  margin: -@space-8 0 @space-8 @space-12;
}

.banner-bundle-note {
  font-size: @fontSize;
  margin: 0 20px;
}

.bundle-component-header-text {
  font-size: @headerFontSize;
  font-weight: 500;
  margin: @space-16 0 0 @space-12;
  padding: @space-8;
}
